import { useDispatch } from 'react-redux';
import _ from '@lodash';
import axios from 'axios';
import { showMessage } from 'app/store/fuse/messageSlice';
import { Button, CircularProgress } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { CheckCircle, Error } from '@material-ui/icons';
import nBossConnection from 'modules/base/service/nBossConnection';
import AdatlapService from '../service/AdatlapService';

const FileUploadStatus = {
	STARTED: 'Started',
	UPLOADING: 'Uploading',
	DONE: 'Done',
	ERROR: 'Error'
};
function FeltoltesTesztlapSecondStep(props) {
	const dispatch = useDispatch();
	const { onSelectedFileCount, onUploadDone, uploadDto } = props;
	const fileInputRef = useRef(null);
	const [fileList, setFileList] = useState([]);
	const [uploadStatus, setUploadStatus] = useState([]);

	const handleFileChange = e => {
		if (e.currentTarget.files) {
			setFileList(Object.keys(e.currentTarget.files).map(key => e.currentTarget.files[key]));
		} else {
			setFileList([]);
		}
	};

	const handleUploadDone = () => {
		AdatlapService.insertSheets(uploadDto.packageName, uploadDto.paperType, uploadDto.examId).then(resp => {
			onUploadDone(resp && resp.successful);
		});
	};

	useEffect(() => {
		onSelectedFileCount(fileList.length);
	}, [fileList]);

	useEffect(() => {
		if (uploadStatus.length > 0) {
			if (fileList.length >= uploadStatus.length) {
				const fileIdx = uploadStatus.length - 1;
				console.log(fileIdx);
				if (uploadStatus[fileIdx] === FileUploadStatus.STARTED) {
					const formData = new FormData();
					formData.append('file', fileList[fileIdx]);
					formData.append('path', JSON.stringify(uploadDto));
					axios
						.post(`${nBossConnection.baseUrl}tesztlapControl/addFile`, formData, {
							headers: {
								'Content-Type': 'multipart/form-data'
							}
						})
						.then(resp => {
							const newUploadStatus = [...uploadStatus];
							newUploadStatus[fileIdx] = resp ? FileUploadStatus.DONE : FileUploadStatus.ERROR;
							if (fileList.length > newUploadStatus.length) {
								newUploadStatus.push(FileUploadStatus.STARTED);
							} else {
								handleUploadDone();
							}
							setUploadStatus(newUploadStatus);
						})
						.catch(err => {
							console.log(err);
							const newUploadStatus = [...uploadStatus];
							newUploadStatus[fileIdx] = FileUploadStatus.ERROR;
							if (fileList.length > newUploadStatus.length) {
								newUploadStatus.push(FileUploadStatus.STARTED);
							} else {
								handleUploadDone();
							}
							setUploadStatus(newUploadStatus);
						});
					setUploadStatus(
						uploadStatus.map((d, i) => {
							if (i === fileIdx) return FileUploadStatus.UPLOADING;
							return d;
						})
					);
				}
			}
		}
	}, [uploadStatus, fileList]);

	useEffect(() => {
		if (uploadDto != null) {
			setUploadStatus([FileUploadStatus.STARTED]);
		}
	}, [uploadDto]);

	return (
		<div className="flex flex-col rounded-8 border px-16 pt-10 pb-4 mb-16">
			<div className="my-16">
				<label htmlFor="contained-button-file">
					<input accept="image/*" className="hidden" id="contained-button-file" multiple type="file" ref={fileInputRef} onChange={e => handleFileChange(e)} />
					<Button variant="contained" color="primary" component="span">
						Fájlok kiválasztása
					</Button>
				</label>
			</div>
			{fileList.map((file, idx) => (
				<div className="my-16 flex flex-row" key={idx} style={{ minHeight: '24px' }}>
					<div className="font-bold mr-8">{`${idx + 1}.`}</div>
					<div className="flex-1">{file.name}</div>
					<div className="mx-8">{!_.isUndefined(uploadStatus[idx]) && <RenderFileUploadStatus status={uploadStatus[idx]} />}</div>
				</div>
			))}
		</div>
	);
}

function RenderFileUploadStatus(props) {
	const { status } = props;
	if (status === FileUploadStatus.STARTED || status === FileUploadStatus.UPLOADING) return <CircularProgress size={24} className="text-blue-600" />;
	if (status === FileUploadStatus.DONE) return <CheckCircle size={24} className="text-green-700" />;
	if (status === FileUploadStatus.ERROR) <Error size={24} className="text-red-600" />;
}
export default FeltoltesTesztlapSecondStep;
